import React from "react";
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import LandingPage from "./views/LandingPage.js";
import LoginPage from "./views/LoginPage.js";
import PrivacyPolicy from "./views/PrivacyPolicy.js";
import AboutUs from "./views/AboutUs";
import AuthLoading from './views/AuthLoading';
import { Provider } from "react-redux";
import ProtectedRoute from './views/ProtectedRoute';
import MyProfile from './views/MyProfile';
import BookingHistory from './views/BookingHistory';
import Dashboard from './views/Dashboard';
import Pricing from './views/Pricing';
import AddBookings from './views/AddBookings';
import Promos from './views/Promos';
import Users from './views/Users';
import Notifications from './views/Notifications';
import Settings from './views/Settings.js';
import CancellationReasons from './views/CancellationReasons';
import AddMoney from "./views/AddMoney";
import DeductFromWallet from "./views/DeductFromWallet";
import Withdraws from './views/Withdraws';
import AllReports from "./views/AllReports";
import { FirebaseProvider, store } from "common";
import { FirebaseConfig } from './config/FirebaseConfig';
import { GoogleMapApiConfig } from './config/GoogleMapApiConfig';
import { GoogleMapApiOptions } from './mapConfig';
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import ContactUs from "./views/ContactUs";
import UserWallet from "./views/UserWallet";
import CarsList from "./views/CarsList";
import {ThemeProvider} from '@mui/styles';
import {createTheme} from '@mui/material';
import { useJsApiLoader } from '@react-google-maps/api';
import TermCondition from "views/TermCondition.js";
import Complain from "views/Complain.js";
import DisputesList from "views/DisputesList.js";
import DisputeDetails from "views/DisputeDetails.js";
import { GoogleOAuthProvider } from '@react-oauth/google';
import { webClientId } from "config/ClientIds.js";
import { HelmetProvider } from "react-helmet-async";
import Chat from "views/Chat.js";
import BookingDetails from "views/BookingDetails.js";
import AddRiders from "views/AddRiders.js";
import CustomerDetails from "views/CustomerDetails.js";
import UserDocuments from "views/UserDocuments.js";
import Error from "views/Error.js";
import AddDriver from "views/AddDriver.js";
import DriverDetails from "views/DriverDetails.js";
import AddFleetAdmin from "views/AddFleetAdmin.js";
import UpdateFleetAdmin from "views/UpdateFleetAdmin.js";
import AddAdmin from "views/AddAdmin.js";
import UpdateAdmin from "views/UpdateAdmin.js";
import AddCarType from "views/AddCarType.js";
import UpdateCarType from "views/UpdateCarType.js";
import UpdateCar from "views/UpdateCar.js";
import AddCar from "views/AddCar.js";
import AddPromo from "views/AddPromo.js";
import UpdatePromo from "views/UpdatePromo.js";
import AddNotifications from "views/AddNotifications.js";
import Sos from "views/Sos.js";
import LiveTrackTrip from "views/LiveTrackTrip.js";

// Use the libraries defined in GoogleMapApiOptions
const libraries = GoogleMapApiOptions.libraries;

i18n
.use(initReactI18next) 
.init({
    resources: {},
    fallbackLng: "en",
    ns: ["translations"],
    defaultNS: "translations",
    interpolation: {
        escapeValue: false
    }
});

function App() {

useJsApiLoader({
    id: 'google-map',
    googleMapsApiKey: GoogleMapApiConfig,
    version: GoogleMapApiOptions.v,
    libraries
  })

  const theme = createTheme()

  return (
    <HelmetProvider>
    <Provider store={store}>
      <FirebaseProvider config={FirebaseConfig}>
        <GoogleOAuthProvider clientId={webClientId}>
          <ThemeProvider theme={theme}>
            <AuthLoading>
              <BrowserRouter>
              <Routes>
                <Route path="/dashboard" element={<ProtectedRoute permit={"admin,fleetadmin"} menuPos={1}><Dashboard /></ProtectedRoute>}/>
                <Route path="/bookings" element={<ProtectedRoute permit={"customer,admin,driver,fleetadmin"} menuPos={2}><BookingHistory /></ProtectedRoute>}/>
                <Route path="/bookings/bookingdetails/:id" element={<ProtectedRoute permit={"customer,admin,driver,fleetadmin"} menuPos={2}><BookingDetails /></ProtectedRoute>}/>
                <Route path="/profile" element={<ProtectedRoute permit={"customer,admin,driver,fleetadmin,subadmin"}><MyProfile /></ProtectedRoute>}/>
                <Route path="/pricing" element={<ProtectedRoute permit={"admin"} menuPos={5}><Pricing/></ProtectedRoute>}/>
                <Route path="/cars" element={<ProtectedRoute permit={"admin,fleetadmin,driver"} menuPos={6}><CarsList /></ProtectedRoute>}/>
                <Route path="/cancelreasons" element={<ProtectedRoute permit={"admin"} menuPos={13}><CancellationReasons /></ProtectedRoute>}/>
                <Route path="/addbookings" element={<ProtectedRoute permit={"admin,fleetadmin,customer"} menuPos={3}><AddBookings /></ProtectedRoute>}/>
                <Route path="/promos" element={<ProtectedRoute permit={"admin"} menuPos={11}><Promos /></ProtectedRoute>}/>
                <Route path="/users/:id" element={<ProtectedRoute permit={"admin,fleetadmin"} menuPos={4}><Users /></ProtectedRoute>}/>
                <Route path="/notifications" element={<ProtectedRoute permit={"admin"} menuPos={12}><Notifications /></ProtectedRoute>}/>
                <Route path="/addtowallet" element={<ProtectedRoute permit={"admin"} menuPos={7}><AddMoney /></ProtectedRoute>}/>
                <Route path="/deductfromwallet" element={<ProtectedRoute permit={"admin"} menuPos={8}><DeductFromWallet /></ProtectedRoute>}/>
                <Route path="/userwallet" element={<ProtectedRoute permit={"customer,driver,fleetadmin"}><UserWallet /></ProtectedRoute>}/>
                <Route path="/withdraws" element={<ProtectedRoute permit={"admin"} menuPos={9}><Withdraws /></ProtectedRoute>}/>
                <Route path="/allreports" element={<ProtectedRoute permit={"admin,fleetadmin"} menuPos={14}><AllReports /></ProtectedRoute>}/>
                <Route path="/complain" element={<ProtectedRoute permit={"admin"} menuPos={16}><Complain /></ProtectedRoute>}/>
                <Route path="/disputes" element={<ProtectedRoute permit={"admin"} menuPos={18}><DisputesList /></ProtectedRoute>}/>
                <Route path="/dispute-details/:id" element={<ProtectedRoute permit={"admin"} menuPos={18}><DisputeDetails /></ProtectedRoute>}/>
                <Route path="/settings" element={<ProtectedRoute permit={"admin"} menuPos={17}><Settings /></ProtectedRoute>}/>
                <Route path="/chat" element={<ProtectedRoute permit={"admin"} menuPos={10}><Chat /></ProtectedRoute>}/>
                <Route path="/contact-us" element={<ContactUs />} />
                <Route path="/about-us" element={<AboutUs />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/term-condition" element={<TermCondition />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/users/addrider" element={<ProtectedRoute permit={"admin,fleetadmin"} menuPos={4}><AddRiders/></ProtectedRoute>}/>
                <Route path="/users/customerdetails/:id" element={<ProtectedRoute permit={"admin,fleetadmin"} menuPos={4}><CustomerDetails/></ProtectedRoute>} />
                <Route path="/users/userdocuments/:rId/:id" element={<ProtectedRoute permit={"admin,fleetadmin"} menuPos={4}><UserDocuments/></ProtectedRoute>} /> 
                <Route path="/userdocuments" element={<ProtectedRoute permit={"admin,fleetadmin"}><UserDocuments/></ProtectedRoute>} />
                <Route path="/users/adddriver" element={<ProtectedRoute permit={"admin,fleetadmin"} menuPos={4}><AddDriver/></ProtectedRoute>}/>
                <Route path="/users/driverdetails/:id" element={<ProtectedRoute permit={"admin,fleetadmin"} menuPos={4}><DriverDetails/></ProtectedRoute>} />
                <Route path="/users/addfleetadmin" element={<ProtectedRoute permit={"admin"} menuPos={4}><AddFleetAdmin/></ProtectedRoute>}/>
                <Route path="/users/fleetadminupdate/:id" element={<ProtectedRoute permit={"admin"} menuPos={4}><UpdateFleetAdmin/></ProtectedRoute>} /> 
                <Route path="/users/addadmin" element={<ProtectedRoute permit={"admin"} menuPos={4}><AddAdmin/></ProtectedRoute>}/>
                <Route path="/users/adminupdate/:id" element={<ProtectedRoute permit={"admin"} menuPos={4}><UpdateAdmin/></ProtectedRoute>}/> 
                <Route path="/pricing/addcartype" element={<ProtectedRoute permit={"admin"} menuPos={5}><AddCarType/></ProtectedRoute>}/>
                <Route path="/pricing/updatecartypes/:id" element={<ProtectedRoute permit={"admin"} menuPos={5}><UpdateCarType/></ProtectedRoute>}/>
                <Route path="/cars/addcar" element={<ProtectedRoute permit={"admin,fleetadmin,driver"} menuPos={6}><AddCar/></ProtectedRoute>}/>
                <Route path="/cars/updatecar/:id" element={<ProtectedRoute permit={"admin,fleetadmin,driver"} menuPos={6}><UpdateCar/></ProtectedRoute>}/>
                <Route path="/promos/addpromo" element={<ProtectedRoute permit={"admin"} menuPos={11}><AddPromo/></ProtectedRoute>}/>
                <Route path="/promos/updatepromo/:id" element={<ProtectedRoute permit={"admin"} menuPos={11}><UpdatePromo/></ProtectedRoute>}/>
                <Route path="/notifications/addnotifications" element={<ProtectedRoute permit={"admin"} menuPos={12}><AddNotifications/></ProtectedRoute>}/>
                <Route path="/sos" element={<ProtectedRoute permit={"admin"} menuPos={15}><Sos /></ProtectedRoute>}/>
                <Route path="/track/:token" element={<LiveTrackTrip />} />
                <Route path="/*" element={<Error/>} />
                <Route path="/" element={<LandingPage />} />
              </Routes>
              </BrowserRouter>
              </AuthLoading>
            </ThemeProvider>
          </GoogleOAuthProvider>
        </FirebaseProvider>
      </Provider>
      </HelmetProvider>
  );
}

export default App;